<script>
import TwButton from '@/components/generic/tw-button.vue'
import TwDropdownItem from '@/components/generic/dropdown/tw-dropdown-item.vue'

import btnPropsMixin from '@/mixins/btnPropsMixin.js'
import { useFundraiserStore } from '@/stores/fundraiser.js'


export default {
  name: 'FundraiserRebuildCacheButton',
  components: { TwButton, TwDropdownItem },
  mixins: [btnPropsMixin],
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    component: {
      type: String,
      default: 'tw-button'
    }
  },
  emits: ['start', 'end'],
  methods: {
    async rebuildCache() {
      if(confirm(`Rebuild frontend cache for ${this.fundraiser.title} campaign?`)) {
        this.$notify('Rebuilding cache...', 'warning')
        await useFundraiserStore().rebuildCache(this.fundraiser.id)
        this.$notify('Cache rebuilt successfully', 'success')
      }
    }
  }
}
</script>

<template>
  <component :is="component" :variant="variant" :size="size" @click="rebuildCache">
    Rebuild Frontend Cache
  </component>
</template>

<style scoped>

</style>
